/* Utility methods on this.$util */

export const $util = {
  errorToast(message, option = {}) {
    // @ts-ignore
    return window.$nuxt.$root.$bvToast.toast(message, {
      title: 'エラー',
      variant: 'danger',
      'no-auto-hide': true,
      autoHideDelay: 1000000, // 1000000 sec
      ...option,
    })
  },
  successToast(message, option = {}) {
    // @ts-ignore
    return window.$nuxt.$root.$bvToast.toast(message, {
      title: '成功',
      variant: 'success',
      solid: true,
      autoHideDelay: 10000, // 10 sec
      ...option,
    })
  },
  warningToast(message, option = {}) {
    // @ts-ignore
    return window.$nuxt.$root.$bvToast.toast(message, {
      title: '',
      variant: 'warning',
      solid: true,
      autoHideDelay: 10000, // 10 sec
      ...option,
    })
  },
  infoToast(message, option = {}) {
    // @ts-ignore
    return window.$nuxt.$root.$bvToast.toast(message, {
      title: '',
      variant: 'info',
      solid: true,
      autoHideDelay: 10000, // 10 sec
      ...option,
    })
  },
  invalidDataWarningToast(message, option = {}) {
    // @ts-ignore
    return window.$nuxt.$root.$bvToast.toast(message, {
      title: '設定が正しくありません',
      variant: 'warning',
      class: 'position-fixed fixed-bottom m-0 rounded-0',
      'no-auto-hide': true,
      autoHideDelay: 1000000, // 1000000 sec
      ...option,
    })
  },
  confirmDialog(message, option = {}): Promise<boolean> {
    // @ts-ignore
    return window.$nuxt.$root.$bvModal.msgBoxConfirm(message, {
      title: null,
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'primary',
      okTitle: 'OK',
      cancelTitle: 'キャンセル',
      footerClass: 'p-2',
      centered: true,
      noCloseOnBackdrop:true,
      ...option,
    })
  },
}

export default $util
